import { render } from "./IconLogo.vue?vue&type=template&id=0d925b0a"
const script = {}
script.render = render

export default script